module.exports = __webpack_public_path__ + "img/upmood_watch_1.1adbc46f.png";